@if (!isNative) {
  @if (redirectPath(); as path) {
    <lib-blocked-web-view [path]="path"></lib-blocked-web-view>
  }
}
